module.exports = __webpack_public_path__ + "img/darts-list.svg?321f7959e138a37754a3cc4d5c21960f";